import { render, staticRenderFns } from "./InsuranceCenturyCalculator.vue?vue&type=template&id=23cb91c4"
import script from "./InsuranceCenturyCalculator.vue?vue&type=script&lang=ts"
export * from "./InsuranceCenturyCalculator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports